import { useCallback, useEffect, useMemo, useState } from "react";

import useApiRequestPost from "../../components/apiHooks/useApiRequestPost";
import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import { usePaymentActions } from "../../contexts/PaymentContext/PaymentContext";

const HOST: string = process.env.CLOUD_RUN_GATEWAY_HOST ?? "";
const END_POINT: string = process.env.API_PAYMENT_METHODS ?? "";

const url: string = `${HOST}${END_POINT}`;

const useGetPaymentMethods = () => {
	const [isLoading, setIsLoading] = useState(false);
	const { state: locationId } = useConfigContext((state) => state.location?.id);
	const paymentActions = usePaymentActions();
	const payload = useMemo(
		() => ({
			url: locationId ? url : "", // Only set URL when location ID exists
			triggerOnMount: false,
			body: {
				uuid: locationId ?? "",
			},
			swrConfig: {
				revalidateOnFocus: false,
				revalidateOnReconnect: false,
				revalidateIfStale: false,
				shouldRetryOnError: false,
				errorRetryInterval: 0,
				errorRetryCount: 0,
				revalidate: false,
			},
		}),
		[locationId, url]
	);

	const { data: response, postData, error } = useApiRequestPost(payload);

	const getPaymentMethods = useCallback(async () => {
		if (!locationId) {
			console.warn("No location ID available for payment methods request");

			return;
		}

		setIsLoading(true);

		try {
			await postData();
			// Ensure loading is set to false after successful request
			setIsLoading(false);
		} catch (err) {
			setIsLoading(false);
			console.error("Failed to get payment methods:", err);
		}
	}, [postData, locationId]);

	useEffect(() => {
		if (!response) return;

		// Extract paymentMethods from response
		const paymentMethods = response?.paymentMethods || [];

		paymentActions.SET_PAYMENT_METHODS(paymentMethods);
	}, [response, paymentActions]);

	return { getPaymentMethods, isLoading, response, error };
};

export default useGetPaymentMethods;
